import React from 'react';
import { styled } from '@mui/material';
import { Button } from '@mui/material';

const Root = styled(Button)(({ theme }) => ({
	width: 'fit-content',
	padding: '8px 25px',
	textTransform: 'none',
	borderRadius: 20,
	color: theme.palette.text.primary,
	backgroundColor: theme.palette.surface.light,
	'&:hover': {
		backgroundColor: theme.palette.surface.main
	},
	'&:disabled': {
		color: theme.palette.text.contrast,
		backgroundColor: theme.palette.primary.main
	}
}));

const ExpirationOptionChip = ({ label, active, value, onClick }) => {
	return (
		<Root disabled={active} onClick={(_e) => onClick(value)}>
			{label}
		</Root>
	);
};

export default ExpirationOptionChip;
